<template>
  <div>
    <van-popup round style="width: 80%" v-model="showTag" @closed="onClosed">
      <h3 class="icon pt20 pb10 pl15 pr15 fs16">
        专属客服电话
        <p class="fs12 color_999 mt5">工作时间:周一至周五</p>
        <p class="fs12 color_999">上午 8:00~11:30 下午 13:30~17:00</p>
      </h3>
      <div class="pt20 pb20 flex pl15 flex-center">
        <img width="35" height="35" src="./assets/电话@3x.png" alt="">
        <p class="fs30 ml10 color_main">{{ tel }}</p>
      </div>

      <div class="flex jcsb pl20 pr20 pb30 pt20">
        <a @click="close" class="bg_eee color_666 pl20 pr20 pt10 pb10 radius20">暂不联系</a>
        <a :href="href" class="bg_main color_fff pl20 pr20 pt10 pb10 radius20">立即拨打</a>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "kefu-call",
  data() {
    return {
      tel: "0571-87767077",
      showTag: false
    }
  },
  computed: {
    href() {
      let tel = this.tel || "";
      return "tel:" + tel.replace(/-/g, '')
    }
  },
  methods: {
    open() {
      this.showTag = true;
    },
    close() {
      this.showTag = false;
    },
    onClosed() {
      if (this.remove) this.remove(this.type);
    },
    onClick(type) {
      this.type = type;
      this.close()
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/plugins/dialog/kefu-call.vue